import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventCardIcon } from "../../EventCardIcon";
import { createEmptyTooltipIcon } from "./createEmptyTooltipIcon";

export const renderLiveStreamingIcon = (hasLiveStream: boolean, liveStreamingTooltip: string, showEmptyIcon: boolean, handler?: React.MouseEventHandler) => {
    const props = {
        className: "rj-ev-list__ev-card-icon--tooltip",
        tooltip: liveStreamingTooltip,
        onClick: handler
    };
    if (hasLiveStream) {
        return <EventCardIcon {...props}>
                    <Icon i="i-24-16 i-o-ev-streaming" />
                </EventCardIcon>
    }

    return showEmptyIcon && createEmptyTooltipIcon();
}